import Saw from './lib/Saw';

export default string => new Saw(string);